<template>
  <tbody>
    <tr :class="{ 'row-active': this.isEditting}">
      <td class="table-body">
        <span>{{ location.stateLocationId }} - </span>
        <router-link
          title="View Location Profile"
          :to="{
            name: 'locationDetails',
            params: { id: location.stateLocationId },
          }"
        >
          {{ location.location.name }}
        </router-link>
        <span class="has-text-grey is-italic">
          ({{ location.locationOrganization.localCode }}) -
           {{ location.locationOrganization.street1 }},
          {{ location.locationOrganization.city }},
          {{ location.locationOrganization.stateCode }}
          {{ location.locationOrganization.zip }}
        </span>
      </td>
      <td>
        <span>{{ this.location.startDate | formatDate }}</span>
      </td>
      <td>
        <span>{{ this.location.endDate | formatDate }}</span>
      </td>
      <td>
        <span :title="location.totalLocations+ ` locations(s)`">
          {{ location.sublocationCount }}
        </span>
      </td>
      <td class="table-action">
        <div class="icon">
          <font-awesome-icon
            title="Edit Location List"
            :icon="['fal', 'edit']"
            class="has-text-primary lg"
            :class="{ 'disabled-icon': disableEdits }"
            @click="toggleEdit"
          />
        </div>
        <div class="icon">
          <font-awesome-icon
            title="Remove from the location list"
            :icon="['fal', 'trash']"
            class="has-text-primary lg"
            :class="{ 'disabled-icon': disableEdits }"
            @click="toggleModal(location)"
          />
        </div>
        <div class="icon">
          <router-link
            :to="{
              name: 'groupLocationList',
              params: { groupId: groupId, locationId: location.stateLocationId },
              query: { childLevel: location.childLevel+1, parentId: location.stateLocationId },
            }"
            :event="!disableEdits ? 'click' : ''"
          >
            <font-awesome-icon
              title="View Location List"
              :icon="['fal', 'angle-double-right']"
              class="has-text-primary lg"
              :class="{ 'disabled-icon': disableEdits }"
            />
          </router-link>
        </div>
      </td>
    </tr>
    <tr class="row-edit" v-if="this.isEditting === true">
      <td colspan="100%">
        <div class="columns is-mobile">
          <div class="column">
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Start Date</label>
              </div>
              <div class="field-body is-block">
                <div class="field">
                  <div class="control">
                    <input type="date" class="calendar"
                      v-model="startDate"
                      @change.prevent="checkFormat('startDate')">
                  </div>
                </div>
                <p v-if="hasErrorStartDate" class="help is-danger">{{ msgStartDate }}</p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">End Date</label>
              </div>
              <div class="field-body is-block">
                <div class="field">
                  <div class="control">
                    <input type="date" class="calendar"
                      v-model="endDate"
                      @change.prevent="checkFormat('endDate')">
                  </div>
                </div>
                <p v-if="hasErrorEndDate || hasErrorRange" class="help is-danger">
                  {{ msgEndDate }}
                </p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="update-box">
              <a @click="cancelEdit">Cancel</a>
              <button class="button is-primary" @click="updateLocation">
                Update
              </button>
            </div>
          </div>
          <div class="column is-full">
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
  faEdit,
  faTrash,
} from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import DateUtils from '@/mixins/DateUtils';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faAngleDoubleRight,
  faEdit,
  faTrash,
);

export default {
  mixins: [DateUtils, NotificationManager],
  props: ['location', 'groupId', 'disableEdits'],
  data() {
    return {
      isEditting: false,
      startDate: null,
      endDate: null,
      showModal: false,
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
      hasErrorStartDate: false,
      msgStartDate: '',
      hasErrorEndDate: false,
      msgEndDate: '',
      hasErrorRange: false,
    };
  },
  mounted() {
    this.copyDates();
  },
  methods: {
    toggleEdit() {
      this.isEditting = !this.isEditting;
      this.resetErrors();
      this.$emit('onEdit');
    },
    toggleModal(location) {
      this.$emit('openModal', location);
    },
    cancelEdit() {
      this.copyDates();
      this.toggleEdit();
      this.hideNotification();
    },
    copyDates() {
      if (this.location.startDate) {
        this.startDate = moment(this.location.startDate).clone().format('YYYY-MM-DD');
      }
      if (this.location.endDate) {
        this.endDate = moment(this.location.endDate).clone().format('YYYY-MM-DD');
      }
    },
    async updateLocation() {
      if (this.checkUpdateForm()) {
        this.showNotification('danger', [this.formErrorMsg]);
        return;
      }
      this.toggleEdit();
      this.hideNotification();
      try {
        await axios.put(`location-groups/${this.groupId}/location-group-mappings/${this.location.stateLocationId}/`, ({
          locationGroupId: this.groupId,
          stateLocationId: this.location.stateLocationId,
          parentId: this.location.parentId,
          childLevel: this.location.childLevel,
          startDate: this.startDate,
          endDate: this.endDate,
        }));
        this.$emit('reloadLocations', this.location.stateLocationId);
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';
        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = `${error.response.data.message}`;
        } else {
          apiMsg = 'Something went wrong.';
        }
        this.showNotification('danger', [apiMsg]);
      }
    },
    checkUpdateForm() {
      this.checkFormat('startDate');
      this.checkFormat('endDate');
      return this.hasErrorStartDate
        || this.hasErrorEndDate
        || this.hasErrorRange;
    },
    resetErrors() {
      this.hasErrorStartDate = false;
      this.hasErrorEndDate = false;
      this.hasErrorRange = false;
      this.msgStartDate = '';
      this.msgEndDate = '';
    },
    checkFormat(field) {
      if (field === 'startDate') {
        if (this.startDate === '') {
          this.hasErrorStartDate = true;
          this.msgStartDate = 'Start Date is required.';
        } else if (!this.isValidDateFormat(this.startDate, 'YYYY-MM-DD')) {
          this.hasErrorStartDate = true;
          this.msgStartDate = 'Start Date is invalid.';
        } else {
          this.hasErrorStartDate = false;
          this.msgStartDate = '';
        }
      }
      if (field === 'endDate') {
        if (!this.endDate) {
          this.hasErrorEndDate = false;
          this.msgEndDate = '';
        } else if (!this.isValidDateFormat(this.endDate, 'YYYY-MM-DD')) {
          this.hasErrorEndDate = true;
          this.msgEndDate = 'End Date is invalid.';
        } else {
          this.hasErrorEndDate = false;
          this.msgEndDate = '';
        }
      }
      if (!this.hasErrorStartDate && !this.hasErrorEndDate) {
        if (!this.isValidDateRange()) {
          this.hasErrorRange = true;
          this.msgEndDate = 'End Date cannot be earlier than Start Date.';
        } else {
          this.hasErrorRange = false;
          this.msgEndDate = '';
        }
      }
    },
    isValidDateRange() {
      if (this.startDate && this.endDate) {
        const date1 = this.getCorrectDateFromYYYYMMDDString(this.startDate)
          .getTime();
        const date2 = this.getCorrectDateFromYYYYMMDDString(this.endDate)
          .getTime();
        return (moment(date2).isAfter(date1));
      }
      return true;
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  .row-active
    background-color: rgb(227, 234, 246) !important
  .row-edit
    height: 56px
    border-left: 1px solid #dee2e6
    border-right: 1px solid #dee2e6
    &:hover
      background-color: #fff !important
  .field-label
    white-space: nowrap
  .update-box
    display: flex
    align-items: center
    button
      margin-left: 1rem
  .field
    display: flex
    align-items: center
  .column
    display: flex
    align-items: center
  .disabled-icon
    color: #999 !important
    pointer-events: none
</style>
